import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { CONTACT, whatsappLink } from "@/constants";
import { ConciergePanel } from "@/components/concierge/ConciergePanel";

export const FloatingActions = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-5 right-5 z-[70] flex flex-col items-end gap-3" data-testid="floating-actions">
        <a
          href={whatsappLink("Hello Aero Vista Club, I'd like to enquire about...")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button"
          aria-label={`Chat on WhatsApp ${CONTACT.whatsappDisplay}`}
          className="w-12 h-12 rounded-full bg-[#25D366] text-black flex items-center justify-center shadow-lg shadow-black/50 transition-transform duration-300 hover:scale-105"
        >
          <WhatsAppIcon />
        </a>
        <button
          onClick={() => setOpen((o) => !o)}
          data-testid="concierge-toggle-button"
          aria-label="Open Aerovista Concierge"
          className="group flex items-center gap-3 pl-1.5 pr-5 py-1.5 rounded-full bg-black/80 border border-gold/50 backdrop-blur-xl shadow-lg shadow-black/50 transition-colors duration-300 hover:border-gold"
        >
          <img src="/concierge-avatar.jpg" alt="" className="w-10 h-10 rounded-full object-cover ring-1 ring-gold/60" />
          <span className="text-left">
            <span className="block text-[10px] uppercase tracking-[0.2em] text-gold">Aerovista</span>
            <span className="block text-sm text-white font-light -mt-0.5">Concierge</span>
          </span>
          {open ? <X size={16} className="text-white/60" /> : <MessageCircle size={16} className="text-white/60" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            transition={{ duration: 0.25 }}
            className="fixed z-[69] bottom-24 right-5 w-[min(400px,calc(100vw-2.5rem))] h-[min(620px,calc(100vh-8rem))] rounded-sm border border-white/10 overflow-hidden shadow-2xl shadow-black/70"
            data-testid="concierge-window"
          >
            <ConciergePanel source="concierge" />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1s-.5-.1-.7.1-.8 1-.9 1.2-.3.2-.6.1a7.4 7.4 0 0 1-3.7-3.2c-.3-.5.3-.4.8-1.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6a1.1 1.1 0 0 0-.8.4 3.4 3.4 0 0 0-1.1 2.6 6 6 0 0 0 1.3 3.2 13.6 13.6 0 0 0 5.2 4.6c1.9.8 2.7.9 3.6.8a3.1 3.1 0 0 0 2-1.4 2.5 2.5 0 0 0 .2-1.4c-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.1l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" />
  </svg>
);
